import { STARTER } from 'self-service-api/constants/ProductLevels';
import { useAppSelector } from '../../reducers';
import { isUngatedForSeatsSelector } from '../../selectors/GatingSelectors';
import { productLevelForCoreSeatsSelector } from '../../selectors/ProductConfigsSelectors';
import { hasProductLineInBundledProductInventorySelector, hasProductLineSelectorInProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { isQuantifiableHubSelector, productForSkuIdSelector } from '../../selectors/ProductsSelectors';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
export const useShowPricePerMonthPerSeat = skuId => {
  const hasPricingAndPurchasingSucceeded = useAppSelector(hasPricingAndPurchasingSucceededSelector);
  const product = useAppSelector(state => {
    return !!skuId && hasPricingAndPurchasingSucceeded && productForSkuIdSelector(state, {
      skuId
    });
  });
  const isUngatedForSeats = useAppSelector(isUngatedForSeatsSelector);
  const isQuantifiableHub = useAppSelector(state => skuId && isQuantifiableHubSelector(state, {
    skuId
  }));
  const coreSeatTierOwned = useAppSelector(state => hasPricingAndPurchasingSucceeded ? productLevelForCoreSeatsSelector(state, {
    productConfigurations: []
  }) : null);
  const ownsProductLineViaProducts = useAppSelector(state => {
    return product && hasProductLineSelectorInProductInventorySelector(state, {
      productLine: product.productLine
    });
  });
  const ownsProductLineViaBundle = useAppSelector(state => {
    return product && hasProductLineInBundledProductInventorySelector(state, {
      productLine: product.productLine
    });
  });
  const ownsProductLine = ownsProductLineViaProducts || ownsProductLineViaBundle;
  if (!skuId || !product) {
    return false;
  }
  return isUngatedForSeats && (isQuantifiableHub || !isQuantifiableHub && (
  // If the highest owned tier is free or starter, show the Starter price in "/mo/seat" format on ALL hubs
  coreSeatTierOwned === STARTER && product.productLevel === STARTER ||
  // If looking at merch card of a hub OWNED, show Starter price in "/mo/seat" format
  ownsProductLine && product.productLevel === STARTER));
};